/* Submit the contact form without leaving the page.

   Progressive enhancement only in the loosest sense: n8n replies with JSON,
   not a redirect, so a no-JS submit would land the visitor on a bare JSON
   body. The form is therefore hidden until this wires it up. */

function ismContact() {
    document.querySelectorAll('[data-ism-contact]').forEach((form) => {
        const endpoint = form.getAttribute('action');
        const status = form.querySelector('.ism-form-status');
        const submit = form.querySelector('.ism-form-submit');
        /* No endpoint configured means there is nowhere to deliver: leave the
           form hidden rather than show a control that silently loses messages. */
        if (!endpoint) return;
        form.hidden = false;

        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (!form.reportValidity()) return;

            submit.disabled = true;
            status.textContent = 'Envoi…';
            status.className = 'ism-form-status';

            const payload = Object.fromEntries(new FormData(form).entries());

            try {
                const res = await fetch(endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });
                const data = await res.json().catch(() => {
                    console.warn('Contact form: response was not JSON');
                    return {};
                });

                if (res.ok && data.ok) {
                    form.reset();
                    status.textContent = 'Message envoyé. Nous vous répondons rapidement.';
                    status.classList.add('is-ok');
                } else {
                    /* The visitor gets one fixed sentence. Whatever the endpoint
                       returned is for us, not for them: the browser already
                       enforces the field rules through reportValidity(), so a
                       server message here can only be something they cannot act
                       on — or something we did not mean to publish. */
                    /* Status only. The console is client-side too, so whatever
                       the endpoint returned does not belong here either. */
                    console.warn('Contact form: rejected (HTTP ' + res.status + ')');
                    status.textContent = "L'envoi a échoué. Vous pouvez nous appeler ou réessayer plus tard.";
                    status.classList.add('is-error');
                }
            } catch (err) {
                console.warn('Contact form: submit failed (' + (err && err.name || 'error') + ')');
                status.textContent = "L'envoi a échoué. Vérifiez votre connexion et réessayez.";
                status.classList.add('is-error');
            } finally {
                submit.disabled = false;
            }
        });
    });
}
